import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { ErrorBoundary } from '@/components';

export function MainLayout() {
  return (
    <div className="main-layout">
      <Toaster position="top-center" reverseOrder={false} />
      <main>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
